import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_2 = {
  key: 1,
  class: "widget px-6 py-7 mb-5"
}
const _hoisted_3 = { class: "s14_mobile mb-4" }
const _hoisted_4 = { class: "secondary-font gap-4 mt-0 mb-2" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  key: 0,
  class: "text-red mb-4"
}
const _hoisted_7 = { class: "flex gap-3" }
const _hoisted_8 = ["disabled"]

import { ref } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ImportMembresComponent',
  props: {
        collectiviteId: { type: Number, required: true }
    },
  emits: ['completed'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;

    const loading = ref(false);
    const errorMessage = ref('');
    const importFile = ref<File | null>(null);
    const importDatas = ref([] as Array<any>);
    const showImportSection = ref(false);

    async function downloadCsv() {
        try {
            const response = await axios.get("/backoffice/collectivites/membres/download_csv_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "collectivite_membres_template.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        }
    }

    async function onCsvImportFileLoaded(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            await doPrepareImportFile(file);
            input.value = '';
        }
    }

    async function doPrepareImportFile(csvFile: File) {
        try {
            loading.value = true;
            errorMessage.value = '';
            importFile.value = null;
            importDatas.value = [];

            const formToUpload = new FormData();
            formToUpload.append("import_file", csvFile);
            const response = await axios.post(`/backoffice/collectivites/membres/prepare_import_file`, formToUpload);
            // L'API retourne directement un array de rows
            importDatas.value = response.data || [];
            importFile.value = csvFile;
            showImportSection.value = true;

            if (importDatas.value.length === 0) {
                errorMessage.value = "Aucune donnée valide trouvée dans le fichier";
            }
        } catch (error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Erreur lors de la préparation du fichier";
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function doImportAction() {
        if (importDatas.value.length === 0) { return; }

        try {
            loading.value = true;
            errorMessage.value = '';
            // Extraire seulement les données (sans errors/has_errors)
            const dataToImport = importDatas.value.map((row: any) => row.data || row);
            await axios.post('/backoffice/collectivites/membres/import_file_datas', { 
                import_datas: dataToImport,
                collectivite_id: props.collectiviteId
            });
            
            // Reset
            importFile.value = null;
            importDatas.value = [];
            showImportSection.value = false;
            
            emit('completed');
        } catch(error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Erreur lors de l'importation";
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function cancelImport() {
        importFile.value = null;
        importDatas.value = [];
        showImportSection.value = false;
        errorMessage.value = '';
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      id: "file-upload-membres-details",
      name: "file-upload",
      type: "file",
      accept: ".csv",
      onChange: onCsvImportFileLoaded,
      class: "display-none"
    }, null, 32),
    _createElementVNode("input", {
      id: "file-upload-membres-list",
      name: "file-upload",
      type: "file",
      accept: ".csv",
      onChange: onCsvImportFileLoaded,
      class: "display-none"
    }, null, 32),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (showImportSection.value && importFile.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, " Fichier: " + _toDisplayString(importFile.value.name), 1),
            _createElementVNode("p", _hoisted_5, [
              _cache[1] || (_cache[1] = _createTextVNode("Nombre de membres à importer: ", -1)),
              _createElementVNode("strong", null, _toDisplayString(importDatas.value.length), 1)
            ])
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              onClick: doImportAction,
              class: "btn lg w-100",
              disabled: loading.value
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, "Importer " + _toDisplayString(importDatas.value.length) + " membre(s)", 1)
            ], 8, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              onClick: cancelImport,
              class: "btn lg white2"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", null, "Annuler", -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})